import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AllocationProtocol } from '../../models/allocationProtocol';

@Component({ standalone:false,
  selector: 'app-select-allocation-protocol-dialog',
  templateUrl: 'select-allocation-protocol-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['select-allocation-protocol-dialog.component.scss']
})
export class SelectAllocationProtocolComponent {
  title: string= "Select the allocation to add an allocation override";
  message: string = "Caution: By selecting the allocation below, you will be changing the default allocation behavior.";
  confirmButtonText = "Add Override";
  cancelButtonText = "Cancel";
  allocationProtocols!: AllocationProtocol[];
  selectedAllocationProtocol?: AllocationProtocol;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<SelectAllocationProtocolComponent>) {
    if(data){
        this.title=data.title || this.title;
        this.message = data.message || this.message;
        this.allocationProtocols = data.allocationProtocols;
        if (data.buttonText) {
            this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
            this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
        }
    }
  }

  get canClickConfirm(): boolean{
    return this.selectedAllocationProtocol!=undefined;
  }

  onConfirmClick(): void {
    this.dialogRef.close(this.selectedAllocationProtocol);
  }
  onCancelClick(): void {
    this.dialogRef.close(undefined);
  }

}